import { Product } from '../../domain/types';
import { COLLECTIONS } from '../../domain/collections';
import { db } from '../../infrastructure/firebaseConfig';
import { logger } from '../../infrastructure/logger';
import { PAGINATION, VALIDATION } from '../../domain/constants';
import {
  collection,
  getDocs,
  query,
  limit
} from "firebase/firestore";

export class ProductSearch {
  private collectionName = COLLECTIONS.PRODUCTS;

  async searchProducts(queryStr: string): Promise<Product[]> {
    try {
      if (!queryStr || queryStr.length < VALIDATION.SEARCH_MIN_LENGTH) return [];
      const lowerQ = queryStr.toLowerCase();

      const q = query(collection(db, this.collectionName), limit(PAGINATION.FILTERED_RESULTS_LIMIT));
      const snapshot = await getDocs(q);

      return snapshot.docs
        .map(doc => ({ ...doc.data(), id: doc.id } as Product))
        .filter(p =>
          p.title.toLowerCase().includes(lowerQ) ||
          p.category.toLowerCase().includes(lowerQ) ||
          (p.subCategory && p.subCategory.toLowerCase().includes(lowerQ)) ||
          (p.keywords && p.keywords.some(k => k.toLowerCase().includes(lowerQ)))
        ).slice(0, PAGINATION.SEARCH_RESULTS_LIMIT);
    } catch (error) {
      logger.error('[ProductSearch] Search failed', error);
      return [];
    }
  }
}

export const productSearch = new ProductSearch();
